<template>
  <div class="log">
    <!-- 砍价记录 -->
    <div class="banner">
      <img :src="item.topImg?item.topImg:require('../img/log_banner_null.png')" alt="" style="border-radius: 6px;" />
      <div class="rule flex" id="guize" @click="rule()">活动规则</div>
    </div>
    <van-tabs v-model="active" class="logTab" @click="onClick" id="shangpin">
      <van-tab v-for="(item, index) in tab" :key="index">
        <template #title>{{ item.name }}</template>
        <div class="data" v-if="arr.length && arr.length > 0">
          <van-list v-model="loading" :finished="finished" :finished-text="finishedText" :immediate-check="check" @load="onLoad">
          <van-row
            gutter="15"
            class="item"
            v-for="(item, index) in arr"
            :key="index"
            @click="goodsDetailUrl(item)"
          >
            <van-col span="8">
              <img
                :src="item.coverImg?item.coverImg:require('../img/default.png')"
                alt=""
              />
            </van-col>
            <van-col span="16" :class="active == '0' ? 'in' : 'end'">
              <div class="line1">已砍{{item.currentPrice}}元，最低可砍至<span>¥{{item.minPrice}}</span></div>
              <div class="line2">
                <van-progress
                  :color="active == '0'?'linear-gradient(135deg, #FFA000 0%, #FF6600 100%)':'#BBBBBB'"
                  :track-color="active == '0'?'#FFEEED':'#EEEEEE'"
                  :show-pivot="false"
                  stroke-width="10px"
                  :percentage="item.percentage"
                  style="border-radius: 10px"
                />
              </div>
              <div class="line3">
                <div v-show="active == '1'">发起时间&nbsp;&nbsp;&nbsp;{{item.startTime}}</div>
                <div
                  class="flex"
                  style="justify-content: flex-start; color: #535353"
                  v-show="active == '0'"
                >
                  <date
                    :date="item.restSeconds"
                    :index="index"
                    type="black3"
                  ></date
                  >&nbsp;&nbsp;后<i style="font-style: normal;" v-show="item.userBargainStatus == '1'">砍价</i>结束
                </div>
              </div>
              <div class="line4">
                <a class="btn flex jixu" v-show="item.userBargainStatus == '1'">继续砍价</a>
                <a class="btn flex xiadan" v-show="item.userBargainStatus == '2'">立即下单</a>
                <a class="btn flex" v-show="item.userBargainStatus == '0'||item.userBargainStatus == '3'">已结束</a>
                <a class="btn flex daizhifu" v-show="item.userBargainStatus == '4'">立即付款</a>
              </div>
            </van-col>
          </van-row>
          </van-list>
        </div>
        <div v-if="arr&&arr.length == '0'" class="no-data">
          <img src="../img/log_img_null.png" alt="" style="width: 2.7rem" />
          <p style="color: #999; margin-top: 0.3rem">暂无砍价记录哦~</p>
        </div>
      </van-tab>
    </van-tabs>
    <div class="fixed" id="chakanhongbao" @click="quanyi()">
      <div class="span">&nbsp;</div>
      <div class="text">查看我获得的红包</div>
      <div class="ico flex">
        <img src="../img/jiantou.png" alt="" style="width: 0.28rem" />
      </div>
    </div>
    <van-popup v-model="guize" :close-on-click-overlay="false">
      <div class="wrapper guize" id="guizetankuang">
        <div class="block" style="width: 6rem; margin: 0 auto 0.6rem">
          <h1>活动规则</h1>
          <p class="ql-editor" v-html="item.rule" style="height: 300px; overflow-y: auto"></p>
        </div>
        <img
          src="../img/close.png"
          style="width: 0.6rem"
          @click="ruleguanbi()"
        />
      </div>
    </van-popup>
  </div>
</template>
<script>
import date from "../../common/date/date";
import config from "@/libs/config";
export default {
  data() {
    return {
      active: 0,
      tab: [{ name: "进行中" }, { name: "已结束" }],
      guize: false,
      item: {},
      arr: [],
      page: {
        type: "1",
        page: "1",
        limit: "20",
      },
      loading: false,
      finished: false,
      check:false,
      finishedText:"没有更多了",
      channelType:""
    };
  },
  components: {
    date,
  },
  created() {
    let isPageHide = false;
    window.addEventListener('pageshow', function () {
        if (isPageHide) {
            window.location.reload();
        }
    });
    window.addEventListener('pagehide', function () {
        isPageHide = true;
    });
    this.info();
    this.list()
    this.$nextTick(() => {
      this.$trackFn.load("guize", "view_material", {
        // 活动规则曝光 - 埋点
        page_type: "barg_records_list",
        card_type: "rule",
        sell_type:"retailstore",
              sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"btn"
      });
    });
    this.$nextTick(() => {
      this.$trackFn.load("chakanhongbao", "view_material", {
        // 活动规则曝光 - 埋点
        page_type: "barg_records_list",
        card_type: "hongbao",
        sell_type:"retailstore",
              sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"hongbao",
        material_link:`${config.config().wx}/v/list`
      });
    });
    this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    if(this.channelType == 'app') UnionDrugHealthy.hiddenShareIcon()
  },
  methods: {
    info() {
      this.$api.bargainRecordInfo({}).then((res) => {
        if (res.errno == "0") {
          this.item = res.data;
        }
      });
    },
    list() {
      this.$api.myBargainRecord(this.page).then((res) => {
        if (res.errno == "0") {
          this.arr = this.arr.concat(res.data.body);
            this.loading = false
            // 数据全部加载完成
            if (res.data.body.length < 20) {
              this.finished = true;
            }
            let time1 = new Date().getTime();
            window.onbeforeunload = (e) => {
              let time2 = new Date().getTime();
              let dateDiff = (time2 - time1) / 1000;
              let page_type = "barg_records_list";
              this.$trackFn.view("$pageview", {
                page_type: page_type,
                page_attr:this.page.type == '1'?'ongoing':'finished',
                event_duration: dateDiff,
                sell_type:"retailstore",
                  sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
                  sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              }); // 商品列表页 ——浏览埋点
              sessionStorage.setItem("pageType", page_type);
              // return "关闭提示";
            };

            this.$nextTick(() => {
                this.$trackFn.load("shangpin", "view_material", {
                  // 曝光 - 埋点
                  page_type: "barg_records_list",
                  card_type: "bargain_production",
                  item_id: this.arr[0].skuNo,
                  item_type: "product_id",
                  sell_type:"retailstore",
          sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
          sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
                  material_type:this.arr[0].skuNo,
                  material_link:this.arr[0].goodsDetailUrl
                });
              });
        }
      });
    },
    onLoad() {
      this.page.page++;
      this.list();
    },
    goodsDetailUrl(item){
      if(item.userBargainStatus == '0'||item.userBargainStatus == '3'){
        location.href = `${item.goodsDetailUrl}&recordId=${item.id}`
        // let url = `${item.goodsDetailUrl}&recordId=${item.id}`
        // window.history.pushState(url)
        // window.open(url,"_blank");
        // let url = `${item.goodsDetailUrl.split(/\?(?!.*\?)/)[1]}&recordId=${item.id}`
        // this.$router.push('/detail?'+url)
      }else{
        location.href = item.goodsDetailUrl
        // window.history.pushState(item.goodsDetailUrl)
        // window.open(item.goodsDetailUrl,"_blank");
        // let url = `${item.goodsDetailUrl.split(/\?(?!.*\?)/)[1]}`
        // this.$router.push('/detail?'+url)
      }
      this.$trackFn.send("click_material", {
          page_type: "barg_records_list",
          card_type: "bargain_production",
          item_id: item.skuNo,
          item_type: "product_id",
          sell_type:"retailstore",
          sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
          sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
          material_type:item.skuNo,
          material_link:item.goodsDetailUrl
        });
    },
   getQuery(url){
          let res = {},query=url.split(/\?(?!.*\?)/)[1];
          if(query){
            let arr =query.split("&");
            for(let i = 0, len = arr.length; i < len; i++){
              res[arr[i].split("=")[0]] = arr[i].split("=")[1]
            }
          }
          return res;
    },
    onClick(name) {
      console.log(name);
      if(name == '0') this.page.type = '1'
      if(name == '1') this.page.type = '2'
      this.page.page = '1'
      this.arr=[]
      this.list()
    },
    getMsgFormSon(index) {
      console.log("索引", index);
      // if(this.active == '0'){
      //   let kong = true
      //   kong = this.arr.some( function( item, index, array ){ 
      //     return item.restSeconds > 0; 
      //   })
      //   if(kong){
      //     document.getElementById(`item${index}`).style.display="none"
      //   }else{
      //     this.arr = []
      //     this.finished = false
      //   }
      // }
    },
    quanyi() {
      // location.href = `${config.config().wx}/v/list`;
      window.open(`${config.config().wx}/v/list`,"_blank")
      this.$trackFn.send("click_material", {
          page_type: "barg_records_list",
          card_type: "hongbao",
          sell_type:"retailstore",
              sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
          material_type:"hongbao",
          material_link:`${config.config().wx}/v/list`
        });
    },
    rule(){
      this.guize = true
      this.$trackFn.send("click_material", {
          page_type: "barg_records_list",
          card_type: "rule",
          sell_type:"retailstore",
              sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
          material_type:"btn"
        });
      this.$nextTick(() => {
        this.$trackFn.load("guizetankuang", "view_material", {
          // 活动规则曝光 - 埋点
          page_type: "barg_records_list",
          card_type: "rule_popup",
         sell_type:"retailstore",
              sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
          material_type:"popup"
        });
      });
      this.$nextTick(() => {
        this.$trackFn.load("guizetankuang", "view_material", {
          // 活动规则曝光 - 埋点
          page_type: "barg_records_list",
          card_type: "rule_bar",
          sell_type:"retailstore",
              sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
          material_type:"close"
        });
      });
    },
    ruleguanbi(){
      this.guize = false
      this.$trackFn.send("click_material", {
          page_type: "barg_records_list",
          card_type: "rule_bar",
          sell_type:"retailstore",
        });
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   from.meta.keepAlive = false;
  //   next();
  // },
};
</script>
<style lang="scss" scoped>
.log {
  .banner {
    position: relative;
    margin: 30px 30px 0;
    border-radius: 14px;
    .rule {
      position: absolute;
      right: 0;
      top: 0.3rem;
      height: 40px;
      width: 112px;
      font-size: 0.2rem;
      color: #fff;
      background: rgba(0, 0, 0, 0.85);
      border-radius: 20px 0px 0px 20px;
      opacity: 0.7;
    }
  }
  .logTab {
    ::v-deep {
      .van-tabs__nav {
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 100%
        );
      }
      .van-tab {
        font-weight: 500;
        color: #888888;
        .van-tab__text{
        font-size: 14px;
        }
      }
      .van-tab--active {
        color: #333333;
        .van-tab__text {
          font-size: 16px;
          font-weight: 600;
        }
      }
      .van-tabs__content {
        margin-top: 0.3rem;
        margin-bottom: 2rem;
      }
    }
    .data {
      background: #ffffff;
      // ::v-deep.van-list:last-child.van-row{
        // background: #c00;
        // ::v-deep.van-col{
        //   border-bottom:none
        // }
      // }
      .item {
        padding: 0.4rem 0.3rem 0;
        ::v-deep {
          .van-col--16 {
            border-bottom: 1px solid #eee;
          }
        }
        .in {
          .line1,
          .line2,
          .line3,
          .line4 {
            font-size: 26px;
            color: #333333;
            line-height: 1;
            span {
              color: #ff5d5d;
            }
          }
          .line1{
            font-family: PingFangSC-Medium, PingFang SC;
            span{
              font-family: PingFangSC-Medium, PingFang SC;
            }
          }
          .line1,
          .line2 {
            padding-bottom: 0.3rem;
          }
          .line3,
          .line4 {
            padding-bottom: 0.4rem;
          }
          .jixu,
          .xiadan {
            box-shadow: 0px 8px 12px 0px rgba(224, 32, 32, 0.2);
          }
          .jixu {
            background: linear-gradient(135deg, #ffa000 0%, #ff6600 100%);
          }
          .xiadan,.daizhifu{
            background: linear-gradient(114deg, #f26b57 0%, #f83a2c 100%);
          }
        }
        .end {
          .line1,
          .line2,
          .line3,
          .line4 {
            font-size: 26px;
            color: #bbbbbb;
            line-height: 1;
            span {
              color: #ff5d5d;
            }
          }
          .line1,
          .line2 {
            padding-bottom: 0.3rem;
          }
          .line3,
          .line4 {
            padding-bottom: 0.4rem;
          }
          .btn {
            background: #bbbbbb;
          }
        }
        .btn {
          width: 232px;
          height: 68px;
          font-size: 28px;
          color: #fff;
          border-radius: 12px;
        }
        img {
          border-radius: 14px;
        }
      }
    }
    .no-data {
      text-align: center;
      margin-top: 1rem;
      color: #666;
    }
  }
  .fixed {
    background: #ffffff;
    position: fixed;
    bottom: 0.4rem;
    left: 0.3rem;
    right: 0.3rem;
    padding: 0.3rem 0.3rem 0.3rem 0;
    border-radius: 0.12rem;
    display: inline-flex;
    .span {
      width: 8px;
      height: 30px;
      background: linear-gradient(114deg, #f26b57 0%, #f83a2c 100%);
      border-radius: 0px 4px 4px 0px;
      margin-right: 0.3rem;
      margin-top: 0.05rem;
    }
    .text {
      margin-right: auto;
      font-size: 30px;
      color: #333333;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  .block {
    margin: 0 0.8rem 0.6rem;
    padding: 0 0.48rem 0.42rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.2rem;
  }
}
.guize {
  h1 {
    font-size: 0.36rem;
    color: #3a3a3a;
    padding: 0.4rem 0 0.3rem;
    text-align: center;
  }
  p {
    font-size: 0.28rem;
    color: #535353;
    // padding-bottom: 0.2rem;
  }
}
::v-deep.van-popup--center {
  background-color: unset;
}
img {
  vertical-align: bottom;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
